import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import type { ControllerDetails } from '#services/cve/ControllerDetails';
import { IterationStatusCode, LineOfBusiness, VettingIteration } from '#services/cve/VettingIteration';

export const pecMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId$',
    },
    response: {
      status: 200,
      body: {
        iterationId: 'iterationId',
        lineOfBusiness: LineOfBusiness.TCI,
        companyId: '113',
        statusCode: IterationStatusCode.CREATED,
        creation: {
          creationDateTime: '2024-04-19T10:05:42.156Z',
          creatorId: 'CVE',
          ownerId: 'CVE',
        },
        controls: [
          {
            controlCode: 'CompanyGrade',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'CompanyConsortOrCoop',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'AccountOwner',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'AccountDetails',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'BuExchangeGroup',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'MncList',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'PreviousContract',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'PreviousNegociation',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'ProspectLocation',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'UnpaidPremiumAndFees',
            statusCode: ControllerStatus.NOT_STARTED,
          },
        ] satisfies ControllerDetails[],
        customProperties: {},
      } satisfies VettingIteration,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/CompanyGrade$',
    },
    response: {
      status: 200,
      body: {
        statusCode: ControllerStatus.NOT_STARTED,
        controlCode: 'CompanyGrade',
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/CompanyConsortOrCoop$',
    },
    response: {
      status: 200,
      body: {
        statusCode: ControllerStatus.CHECK_REJECTED,
        controlCode: 'CompanyConsortOrCoop',
        check: {
          requestDateTime: '2023-05-18T13:29:56.409Z',
          responseDateTime: '2023-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2025-09-26T00:00:00.000Z',
          controlData: {},
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/AccountOwner$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'AccountOwner',
        statusCode: ControllerStatus.CHECK_SUCCESS,
        check: {
          requestDateTime: '2023-05-18T13:29:56.409Z',
          responseDateTime: '2023-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2023-09-26T00:00:00.000Z',
          controlData: {},
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/AccountDetails$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'AccountDetails',
        statusCode: ControllerStatus.ESCALATING,
        check: {
          requestDateTime: '2023-05-18T13:29:56.409Z',
          responseDateTime: '2023-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2023-09-26T00:00:00.000Z',
          controlData: {},
        },
        escalation: {
          requestDateTime: '2024-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          controlData: {
            companyId: '113',
          },
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/BuExchangeGroup$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'BuExchangeGroup',
        statusCode: ControllerStatus.ESCALATION_ACCEPTED,
        check: {
          requestDateTime: '2023-05-18T13:29:56.409Z',
          responseDateTime: '2023-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2023-09-26T00:00:00.000Z',
          controlData: {},
        },
        escalation: {
          requestDateTime: '2024-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {
            companyId: '113',
            escalationResponse: {
              comment: 'Yes',
              validator: 'johndoe@gmail.fr',
            },
          },
          responseDateTime: '2024-05-28T13:29:56.409Z',
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/MncList$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'MncList',
        statusCode: ControllerStatus.ESCALATION_REJECTED,
        check: {
          requestDateTime: '2023-05-18T13:29:56.409Z',
          responseDateTime: '2023-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2023-09-26T00:00:00.000Z',
          controlData: {},
        },
        escalation: {
          requestDateTime: '2024-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {
            companyId: '113',
            escalationResponse: {
              validator: 'johndoe',
              comment: 'This is not ok',
            },
          },
          responseDateTime: '2024-05-28T13:29:56.409Z',
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/PreviousContract$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'PreviousContract',
        statusCode: ControllerStatus.CHECKING,
        check: {
          requestDateTime: '2023-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          controlData: {},
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/PreviousNegociation$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'PreviousNegociation',
        statusCode: ControllerStatus.MANUAL_CHECK_REQUIRED,
        check: {
          requestDateTime: '2023-05-18T13:29:56.409Z',
          responseDateTime: '2023-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2023-09-26T00:00:00.000Z',
          controlData: {},
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/ProspectLocation$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'ProspectLocation',
        statusCode: ControllerStatus.CHECK_SUCCESS,
        check: {
          requestDateTime: '2023-05-18T13:29:56.409Z',
          responseDateTime: '2023-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2023-09-26T00:00:00.000Z',
          controlData: {},
        },
      } satisfies ControllerDetails,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/UnpaidPremiumAndFees$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'UnpaidPremiumAndFees',
        statusCode: ControllerStatus.CHECK_SUCCESS,
        check: {
          requestDateTime: '2023-05-18T13:29:56.409Z',
          responseDateTime: '2023-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2023-09-26T00:00:00.000Z',
          controlData: {},
        },
      } satisfies ControllerDetails,
    },
  },
];
